<app-skeleton *ngIf="loadingBroadcast" variant="text" [count]="8"
  label="Carregando o broadcast" data-testid="broadcast-loading"></app-skeleton>

<div *ngIf="!loadingBroadcast && broadcastType; else selectBroadcastType">
  <header class="page-head">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-bullhorn"></i></span>
      <div>
        <h1 class="page-head__title">{{ title }}</h1>
      </div>
    </div>
    <div class="page-head__actions">
      <a
        *ngIf="broadcastId"
        [routerLink]="['/broadcasts/new']"
        class="sf-btn sf-btn--secondary me-2"
      >
        <i class="fa fa-envelope-o"></i>
        Novo Broadcast
      </a>
      <button
        class="sf-btn sf-btn--primary me-2"
        (click)="changeBroadcastType('list')"
        type="button"
        *ngIf="broadcastType !== 'list' && !broadcast?.id"
      >
        <i class="fa fa-list"></i>
        Para Lista
      </button>
      <button
        class="sf-btn sf-btn--secondary me-2"
        (click)="changeBroadcastType('number')"
        type="button"
        *ngIf="broadcastType !== 'number' && !broadcast?.id"
      >
        <i class="fa fa-phone"></i>
        Para Números
      </button>
      <button
        class="sf-btn sf-btn--secondary"
        (click)="changeBroadcastType('client')"
        type="button"
        *ngIf="isAdministrator"
      >
        <i class="fa fa-user"></i>
        Para Clientes
      </button>
    </div>
  </header>

  <div
    class="notice notice--success"
    role="status"
    *ngIf="broadcast?.id && isImporting(broadcast)"
    data-testid="broadcast-importing"
  >
    <i class="fa fa-info-circle"></i>
    <div class="notice__body">
      Os Leads deste Broadcast estão sendo importados. Assim que finalizar você será notificado.
    </div>
  </div>

  <form [formGroup]="broadcastForm" (submit)="save()">
    <div class="sf-card broadcast-card">

      <ol class="stepper">
        <li [class.on]="currentStep === 1" [class.done]="currentStep > 1">
          <button type="button" [disabled]="!canGoToStep(1)" [class.editable]="currentStep !== 1 && canGoToStep(1)" (click)="goToStep(1)">
            <span class="n"><i class="fa fa-check" *ngIf="currentStep > 1"></i><ng-container *ngIf="currentStep <= 1">1</ng-container></span>
            <span class="lbl">Destino</span>
            <i class="fa fa-pencil edit-ico" *ngIf="currentStep !== 1 && canGoToStep(1)"></i>
          </button>
        </li>
        <span class="line" [class.done]="currentStep > 1"></span>
        <li [class.on]="currentStep === 2" [class.done]="currentStep > 2">
          <button type="button" [disabled]="!canGoToStep(2)" [class.editable]="currentStep !== 2 && canGoToStep(2)" (click)="goToStep(2)">
            <span class="n"><i class="fa fa-check" *ngIf="currentStep > 2"></i><ng-container *ngIf="currentStep <= 2">2</ng-container></span>
            <span class="lbl">Mensagem</span>
            <i class="fa fa-pencil edit-ico" *ngIf="currentStep !== 2 && canGoToStep(2)"></i>
          </button>
        </li>
        <span class="line" [class.done]="currentStep > 2"></span>
        <li [class.on]="currentStep === 3" [class.done]="currentStep > 3">
          <button type="button" [disabled]="!canGoToStep(3)" [class.editable]="currentStep !== 3 && canGoToStep(3)" (click)="goToStep(3)">
            <span class="n"><i class="fa fa-check" *ngIf="currentStep > 3"></i><ng-container *ngIf="currentStep <= 3">3</ng-container></span>
            <span class="lbl">Agendamento</span>
            <i class="fa fa-pencil edit-ico" *ngIf="currentStep !== 3 && canGoToStep(3)"></i>
          </button>
        </li>
        <span class="line" [class.done]="currentStep > 3"></span>
        <li [class.on]="currentStep === 4">
          <button type="button" [disabled]="!canGoToStep(4)" [class.editable]="currentStep !== 4 && canGoToStep(4)" (click)="goToStep(4)">
            <span class="n">4</span>
            <span class="lbl">Revisar</span>
            <i class="fa fa-pencil edit-ico" *ngIf="currentStep !== 4 && canGoToStep(4)"></i>
          </button>
        </li>
      </ol>

      <div class="notice notice--danger notice--sm" *ngIf="stepError" data-testid="step-error">
        <i class="fa fa-exclamation-triangle"></i>
        <div class="notice__body">{{ stepError }}</div>
      </div>

      <!-- ===== Passo 1 — Destino ===== -->
      <div class="step-panel" [hidden]="currentStep !== 1">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <div class="col-12">
                <div class="notice notice--warning notice--sm">
                  <i class="fa fa-exclamation-triangle"></i>
                  <div class="notice__body">
                    Certifique-se que os números importados são válidos, no formato DDD + 99999-9999.
                  </div>
                </div>
              </div>
              <label for="name">Nome do envio</label>
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="name"
                #nameInput
                data-testid="input-name"
              />
              <small
                *ngIf="broadcastForm.get('name').errors?.required"
                class="text-danger"
              >
                Preencha o nome do envio
              </small>
            </div>
          </div>

          <div class="col-12" *ngIf="broadcastType === 'list'">
            <div class="form-group">
              <label>Lista</label>
              <app-skeleton *ngIf="loadingLists" variant="text" [count]="1"
                label="Carregando as listas" data-testid="lists-loading"></app-skeleton>
              <app-search-select
                *ngIf="!loadingLists"
                [options]="listOptions"
                formControlName="lead_list_id"
                placeholder="Selecione uma lista…"
                searchPlaceholder="Pesquisar lista…"
                noun="listas"
                testId="select-list"
              ></app-search-select>
            </div>
          </div>

          <div class="col-12 mt-2" *ngIf="broadcastType === 'client'">
            <label>Tipo de cliente:</label>
            <div class="d-flex gap-4">
              <app-radio-button
                *ngFor="let profile of profiles"
                name="profile_{{ profile.id }}"
                [text]="profile.name"
                [value]="profile.id"
                [isCheckbox]="true"
                [checked]="profile.selected"
                (onSelect)="profile.selected = $event"
              ></app-radio-button>
            </div>
          </div>

          <div class="col-12" *ngIf="broadcastType === 'number'">
            <div class="form-group">
              <label for="numbers">Números</label>
              <textarea
                data-testid="input-numbers"
                name="numbers"
                id="numbers"
                class="form-control"
                formControlName="numbers"
                rows="8"
                placeholder="Cole aqui os números um abaixo do outro ou separados por vírgulas.

Exemplo:
14999999999
11999999999
-ou-
14999999999, 11999999999"
              ></textarea>
              <small><b>Quantidade:</b> {{ numbersCount }} número(s)</small>
            </div>
          </div>

          <div
            class="col-md-6 mt-3 mb-3"
            *ngIf="broadcastId && broadcastType === 'number'"
          >
            <app-switcher
              display="block"
              label="Excluir contatos existentes?"
              id="delete-contacts"
              [(checked)]="removeContacts"
            ></app-switcher>
          </div>
        </div>
      </div>

      <!-- ===== Passo 2 — Mensagem ===== -->
      <div class="step-panel" [hidden]="currentStep !== 2">
        <div class="notice notice--warning notice--sm">
          <i class="fa fa-exclamation-triangle"></i>
          <div class="notice__body">
            Lembre-se que está enviando SMS e esta tecnologia tem suas restrições, portanto, não utilize acento ou emoji nas mensagens!
          </div>
        </div>

        <div class="form-group">
          <label for="message">Mensagem</label>
          <textarea
            name="message"
            id="message"
            class="form-control"
            formControlName="message"
            maxlength="150"
            rows="3"
            (blur)="setPosition($event)"
            data-testid="input-message"
          ></textarea>
          <small
            class="pull-right"
            *ngIf="
              broadcastForm.get('message').value;
              else textLengthCounter
            "
          >
            {{ broadcastForm.get("message").value.length }}/150
          </small>
          <ng-template #textLengthCounter>
            <small class="pull-right">0/150</small>
          </ng-template>
          <small
            class="text text-danger"
            *ngIf="broadcastForm.get('message').errors?.maxlength"
          >
            O texto deve ter apenas 150 caracteres
          </small>
          <small
            class="text text-danger"
            *ngIf="broadcastForm.get('message').errors?.required"
          >
            Preencha a sua mensagem
          </small>
          <div class="mt-2">
            <div class="mb-2">
              <b>Variáveis que podem ser utilizadas (clique para adicionar)</b>
            </div>
            <label
              *ngFor="let tag of tagsForType"
              ngbTooltip="{{ tag.text }}"
            >
              <span
                class="badge bg-primary me-2"
                (click)="addTag(tag.tag)"
                >{{ "{" + tag.tag + "}" }}</span
              >
            </label>
          </div>
        </div>

        <!-- Só aparece quando a mensagem usa {meu_link} (m8-comum.md). Nunca `*ngIf`:
             tiraria o controle do form (ver nota no .ts sobre `[hidden]`). -->
        <div class="form-group" [hidden]="!messageHasMeuLink">
          <label for="url">Meu link</label>
          <input
            type="text"
            class="form-control"
            name="url"
            id="url"
            placeholder="Exemplo: https://exemplo.com"
            formControlName="url"
          />
          <span
            class="text-danger"
            *ngIf="broadcastForm.get('url').errors?.invalidUrl"
            >URL Inválida! Exemplo: <u>https://exemplo.com</u></span
          >
        </div>

        <div class="form-group" [hidden]="!messageHasMeuLink">
          <app-switcher id="user_active" label="Enviar número do lead na URL?" display="block" [(checked)]="sendLeadNumber" />
        </div>
      </div>

      <!-- ===== Passo 3 — Agendamento ===== -->
      <!-- Janela de envio (m8-comum.md): "Enviar agora" desabilita fora do horário
           global de SMS Massivo (START_BROADCASTS_AT/STOP_BROADCASTS_AT, GET
           /send-windows) e o campo de hora bloqueia o que estiver fora dela. -->
      <div class="step-panel" [hidden]="currentStep !== 3">
        <!-- *ngIf (não [hidden]): só existe enquanto o passo 3 está de fato aberto, para
             o timer de 30s do app-send-when nascer e morrer com a visita ao passo — não
             fica rodando a vida toda do componente (e some nos testes que nunca chegam
             nele, sem vazar setInterval para dentro de fakeAsync de outro teste). Não tem
             formControlName, então não desregistra nada ao sair do passo. -->
        <app-send-when
          *ngIf="currentStep === 3"
          [window]="windows.sms"
          [sendNow]="sendNow"
          (sendNowChange)="setSendNow($event)"
          testId="send"
        ></app-send-when>

        <!-- O picker TEM formControlName: fica montado sempre (só `[hidden]`), senão o
             Angular desregistra `scheduled_date` do broadcastForm ao trocar de passo. -->
        <div class="scheduled-date mt-2" [hidden]="sendNow">
          <div [hidden]="broadcastId && !changeDate">
            <app-window-datetime-picker
              [window]="windows.sms"
              formControlName="scheduled_date"
              testId="broadcast-schedule"
            ></app-window-datetime-picker>
          </div>

          <div [hidden]="!broadcastId || changeDate">
            <label for="date">Agendado para: </label>
            <button
              class="sf-btn sf-btn--primary"
              type="button"
              ngbTooltip="Alterar data"
              (click)="toggleChangeDate()"
            >
              <i class="fa fa-clock-o"></i>
            </button>
            <br />
            <span>{{
              broadcastForm.get("scheduled_date").value
                | date : "dd/MM/yyyy, H:mm"
            }}</span>
          </div>
        </div>
      </div>

      <!-- ===== Passo 4 — Revisar ===== -->
      <div class="step-panel" [hidden]="currentStep !== 4">
        <dl class="def-grid">
          <div class="def">
            <dt>Nome do envio</dt>
            <dd>{{ broadcastForm.get('name').value || '—' }}</dd>
          </div>
          <div class="def">
            <dt>Destino</dt>
            <dd>
              <span class="bind-chip" [class.bind-chip--numbers]="broadcastType === 'number'">
                <i class="fa" [class.fa-list-ul]="broadcastType === 'list'" [class.fa-hashtag]="broadcastType === 'number'" [class.fa-users]="broadcastType === 'client'"></i>
                <ng-container *ngIf="broadcastType === 'list'">Para lista · {{ selectedListLabel }}</ng-container>
                <ng-container *ngIf="broadcastType === 'number'">Para números · {{ numbersCount }}</ng-container>
                <ng-container *ngIf="broadcastType === 'client'">Para clientes</ng-container>
              </span>
            </dd>
          </div>
          <div class="def wide">
            <dt>Mensagem</dt>
            <dd><div class="msg-bubble">{{ broadcastForm.get('message').value }}</div></dd>
          </div>
          <div class="def">
            <dt>Agendamento</dt>
            <dd *ngIf="sendNow">Enviar agora, assim que confirmar</dd>
            <dd *ngIf="!sendNow">{{ broadcastForm.get('scheduled_date').value | date : 'dd/MM/yyyy, H:mm' }}</dd>
          </div>
          <div class="def">
            <dt>Custo estimado</dt>
            <dd>
              <ng-container *ngIf="costEstimate.kind === 'wallet'">
                <strong [class.text-danger]="costEstimate.insufficientFunds">{{ costEstimate.totalMicros | moneyMicros:'BRL':'pt-BR':2:2 }}</strong>
                <span class="field-hint">· disponível {{ costEstimate.availableMicros | moneyMicros:'BRL':'pt-BR':2:2 }}</span>
              </ng-container>
              <span *ngIf="costEstimate.kind === 'credits'">Calculado em créditos no envio</span>
              <span *ngIf="costEstimate.kind === 'unknown'">Calculado no envio</span>
            </dd>
          </div>
        </dl>
        <p class="field-hint review-hint">
          Estimativa pela tarifa atual e pela quantidade de destinatários; o valor exato é debitado conforme as mensagens saem.
          Se faltar saldo na hora de agendar, você confirma o envio parcial ou aguarda uma recarga.
        </p>
      </div>

      <div class="step-nav">
        <button type="button" class="sf-btn sf-btn--secondary" *ngIf="currentStep > 1" (click)="prevStep()">
          <i class="fa fa-chevron-left"></i> Voltar
        </button>

        <button type="button" class="sf-btn sf-btn--primary" *ngIf="currentStep < 4" (click)="nextStep()" data-testid="btn-next">
          Próximo <i class="fa fa-chevron-right"></i>
        </button>

        <ng-container *ngIf="currentStep === 4">
          <button
            class="sf-btn sf-btn--primary"
            [appLoadingButton]="isSaving"
            [disabled]="broadcastForm.invalid"
            data-testid="btn-save"
          >
            {{ sendNow ? 'Enviar agora' : 'Agendar envio' }}
          </button>

          <a [routerLink]="['/broadcasts']" class="sf-btn sf-btn--secondary">Cancelar</a>
        </ng-container>
      </div>
    </div>
  </form>
</div>

<ng-template #selectBroadcastType>
  <!-- `!loadingBroadcast` para a edição não piscar a tela de escolher o tipo
       antes de o broadcast chegar. -->
  <div *ngIf="!loadingBroadcast">
    <header class="page-head">
      <div class="page-head__identity">
        <span class="page-head__icon"><i class="fa fa-bullhorn"></i></span>
        <div>
          <h1 class="page-head__title">{{ title }}</h1>
        </div>
      </div>
    </header>
    <div class="sf-card broadcast-card select-type">
      <div class="row">
        <div class="col mt-3 mb-3">
          <button
            class="sf-btn sf-btn--lg sf-btn--primary"
            (click)="changeBroadcastType('list')"
            data-testid="btn-list"
          >
            <i class="fa fa-list"></i>
            Para Lista
          </button>
          <button
            class="sf-btn sf-btn--lg sf-btn--secondary ms-2"
            (click)="changeBroadcastType('number')"
            data-testid="btn-number"
          >
            <i class="fa fa-phone"></i>
            Para Números
          </button>
          <button
            class="sf-btn sf-btn--lg sf-btn--secondary ms-2"
            (click)="changeBroadcastType('client')"
            *ngIf="isAdministrator"
            data-testid="btn-client"
          >
            <i class="fa fa-user"></i>
            Para Clientes
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
